export const siteConfig = {
  appleStore:
    'https://itunes.apple.com/gb/app/the-sole-supplier/id1436712793?mt=8',
  name: 'The Sole Supplier',
  socialMediaLinks: {
    sneaker: {
      crunchbase: 'https://www.crunchbase.com/organization/the-sole-supplier',
      facebook: 'https://www.facebook.com/thesolesupplier',
      instagram: 'https://www.instagram.com/thesolesupplier/',
      linkedin: 'https://www.linkedin.com/company/thesolesupplier/',
      tiktok: 'https://www.tiktok.com/@thesolesupplier',
      twitter: 'https://twitter.com/thesolesupplier',
      youtube: 'https://www.youtube.com/user/thesolesupplier'
    }
  }
};
